import { useCallback, useState } from "react";
import { Button } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";

interface ReportFileExportButtonProps {
  label: string;
  filename: string;
  fetchFile: () => Promise<Blob>;
  disabled?: boolean;
}

export function ReportFileExportButton({
  label,
  filename,
  fetchFile,
  disabled = false,
}: ReportFileExportButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleExport = useCallback(async () => {
    setLoading(true);
    try {
      const blob = await fetchFile();
      downloadBlob(blob, filename);
    } catch {
      notifications.show({
        title: "Export failed",
        message: "Could not download the report. Please try again.",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  }, [fetchFile, filename]);

  return (
    <Button
      leftSection={<IconDownload size={16} />}
      variant="light"
      loading={loading}
      disabled={disabled}
      onClick={handleExport}
    >
      {label}
    </Button>
  );
}

function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
